import { http } from '@/core/api'
import type {
  AnalyticsV2ConversionResponse,
  AnalyticsV2ExecutiveResponse,
  AnalyticsV2Query,
  AnalyticsV2SourcesResponse,
} from '@/features/analytics/types/analytics-v2.types'

const BASE = '/analytics/v1'

async function get<T>(path: string, params: AnalyticsV2Query): Promise<T> {
  const { data } = await http.get<{ data: T }>(`${BASE}/${path}`, { params })
  return data.data
}

export const analyticsV2Api = {
  executive: (params: AnalyticsV2Query) =>
    get<AnalyticsV2ExecutiveResponse>('executive', params),
  sources: (params: AnalyticsV2Query) =>
    get<AnalyticsV2SourcesResponse>('sources', params),
  conversion: (params: AnalyticsV2Query) =>
    get<AnalyticsV2ConversionResponse>('conversion', params),
}
